import * as React from 'react';

import { Input, InputProps } from '@lightspeed/flame/Input';

import { formatMoney, formatNumberInput, maxMoney } from 'pages/utils/input';
import {
  OverviewDataContext,
  ShipmentPayload,
} from 'root/apps/PurchaseOrder/ShipmentHistory/tabs/View/contexts/OverviewData';

import type { ShipmentOverview } from 'root/apps/PurchaseOrder/ShipmentHistory/types';

interface Props {
  name: keyof ShipmentPayload;
  value: string | number | undefined;
  orderId: ShipmentOverview['orderID'];
  shipmentId: ShipmentOverview['shipmentID'];
  isDisabled: boolean;
}

const ShippingCostInput: React.FC<Props & InputProps> = ({
  name,
  value: originalValue,
  orderId,
  shipmentId,
  isDisabled,
  ...rest
}) => {
  const [value, setValue] = React.useState(formatMoney(originalValue));
  const { saveOverviewData, savingKeys } = React.useContext(OverviewDataContext);

  const saveShippingCost = (newValue: number | string) => {
    if (formatMoney(originalValue) === formatMoney(newValue)) return;
    saveOverviewData({ orderId, shipmentId, payload: { [name]: newValue } });
  };

  React.useEffect(() => {
    const newValue = formatMoney(formatNumberInput(originalValue), true);

    setValue(newValue);
  }, [originalValue]);

  return (
    <Input
      type="number"
      max={maxMoney}
      min={0}
      placeholder="0.00"
      value={value}
      disabled={
        isDisabled ||
        savingKeys?.includes('shippingCost') ||
        savingKeys?.includes('shippingVendorCost')
      }
      name={name}
      id={`${name}-input`}
      aria-label={`${name}-input`}
      onFocus={(event) => {
        window.selectField(event.target);
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
          // @ts-ignore
          event.target.blur();
        }
      }}
      onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => setValue(value)}
      onBlur={({ target: { value } }) => {
        const newValue = formatMoney(formatNumberInput(value || 0), true);

        setValue(newValue);
        saveShippingCost(formatMoney(newValue, true));
      }}
      {...rest}
    />
  );
};

export default ShippingCostInput;
